import { userApi, USER_TOKEN_KEY, formatApiError } from "@/user/api";

// Company Admin reuses the user JWT (role='company_admin'), so we just
// re-export the user axios instance for clarity.
export const caApi = userApi;
export { USER_TOKEN_KEY, formatApiError };
